import { makeStyles } from "@material-ui/styles";

const boxScoreTeamSummaryStyles = makeStyles((theme) => ({
	title: {
		padding: 10
	},
	logo: {
		width: "5vw",
		height: "5vw",
		[theme.breakpoints.only("xs")]: {
			width: "9vw",
			height: "9vw"
		},
		"& img": {
			objectFit: "contain"
		}
	},
	eventText: {
		fontFamily: "Barlow Condensed",
		fontSize: 16,
		fontWeight: 600,
		letterSpacing: 0
	},
	teamNameContainer: {
		marginTop: 24,
		padding: theme.spacing(0, 2)
	},
	summaryContainer: {
		justifyContent: "space-between",
		[theme.breakpoints.only("xs")]: {
			justifyContent: "flex-start"
		}
	}
}));

export default boxScoreTeamSummaryStyles;
